exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-popover-overlay.ant-popover .ant-popover-title {\n  position: relative;\n}\n.fade-enter-active,\n.fade-leave-active {\n  opacity: 1;\n  -webkit-transition: opacity 0.5s;\n  transition: opacity 0.5s;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n", ""]);

// exports
